export default "__VITE_ASSET__5Ly6hvlq__"